import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loading from '../Loading'
import NextPrevBox from '../forms/NextPrevBox'
import { addUrlQuery } from '../../actions/uiActions'

const KATEGORIJAS = [
    { label: 'Saldūdens', match: 'saldūdens' },
    { label: 'Sulfātu ūdens', match: 'sulfātu saldūdens' },
    { label: 'Hlorīdu ūdens', match: 'hlorīdu saldūdens' },
    { label: 'Sulfātu iesāļūdens', match: 'sulfātu iesāļūdens' },
    { label: 'Hlorīdu iesāļūdens', match: 'hlorīdu iesāļūdens' },
    { label: 'Sāļūdens', match: 'sāļūdens' },
    { label: 'Sālsūdens', match: 'sālsūdens' }
]

const TEKOSAIS_GADS = new Date().getFullYear()

const ATSTARPE = /[  ]/g
const SKAITLIS = /\d[\d  ]*(?:[.,]\d+)?/g

const formatSkaitli = (text) => String(text).replace(SKAITLIS, (match) => {
    const num = Number(match.replace(ATSTARPE, '').replace(',', '.'))
    if (!isFinite(num)) return match
    const decimals = /[.,]/.test(match) ? 2 : 0
    return num.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})

const isTuksa = (v) => v === null || v === undefined || String(v).trim() === ''

const val = (v) => isTuksa(v) ? '-' : formatSkaitli(v)

const izmainas = (v) => {
    if (isTuksa(v)) return '-'
    const rindas = String(v).split(/<\/?br\s*\/?>/i).map(r => r.replace(/<[^>]*>/g, '').trim()).filter(Boolean)
    if (!rindas.length) return '-'
    return rindas.map((rinda, i) => <div key={i}>{formatSkaitli(rinda)}</div>)
}

const tdStyle = { textAlign: 'center', verticalAlign: 'middle' }
const numStyle = { ...tdStyle, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }
const grupasStyle = { borderTop: '2px solid #c8c8c8' }

class PazemesUdenuBilanceKopsavilkums extends Component {

    onYearChange = (gads) => {
        this.props.addUrlQuery({ f: JSON.stringify({ izpetes_gads: Number(gads) }) })
    }

    currentYear = () => {
        const { query } = this.props
        const filters = query && query.f ? JSON.parse(query.f) : {}
        return parseInt(filters.izpetes_gads || TEKOSAIS_GADS, 10)
    }

    kategorijuRindas = (list) => {
        const kat = (row) => String(row.krajuma_kategorija || '').trim().toLowerCase()
        const zinamas = new Set(KATEGORIJAS.map(k => k.match))
        const peKategorijas = new Map((list || []).map(row => [kat(row), row]))

        // VVIS krājuma kategorija ir brīvs teksts, tāpēc neatpazītās rādām beigās
        const nezinamas = [...peKategorijas]
            .filter(([k]) => !zinamas.has(k))
            .map(([k, row]) => ({ label: row.krajuma_kategorija, key: `x_${k}`, row }))

        return KATEGORIJAS
            .map(({ label, match }) => ({ label, key: match, row: peKategorijas.get(match) || null }))
            .concat(nezinamas)
    }

    renderKategorijaRindas = ({ label, key, row }) => {
        return ['A', 'N'].map(and => {
            const s = and.toLowerCase()
            const pirma = and === 'A'
            return (
                <tr key={`${key}_${and}`} style={pirma ? grupasStyle : undefined}>
                    <td style={numStyle}>{label} – {and}</td>
                    <td style={numStyle}>{val(row && row[`lidz_1997_apstiprin_${s}`])}</td>
                    <td style={numStyle}>{val(row && row[`sak_kraj_akc_${s}`])}</td>
                    {pirma && <td style={numStyle} rowSpan={2}>{val(row && row.ieguve)}</td>}
                    <td style={tdStyle}>{izmainas(row && row[`kraj_izm_izpete_${s}`])}</td>
                    <td style={tdStyle}>{izmainas(row && row[`kraj_izm_parrek_${s}`])}</td>
                    <td style={numStyle}>{val(row && row[`beig_kraj_apst_${s}`])}</td>
                    <td style={numStyle}>{val(row && row[`beig_kraj_akc_${s}`])}</td>
                    {pirma && <td style={numStyle} rowSpan={2}>{val(row && row.urbumu_skaits)}</td>}
                </tr>
            )
        })
    }

    render() {
        const { pazemesUdenuBilanceKopsavilkums } = this.props
        const { list, loading } = pazemesUdenuBilanceKopsavilkums
        const gads = this.currentYear()

        return (
            <div style={{ padding: '10px', height: '100%', overflow: 'auto' }}>
                <NextPrevBox key={gads} currentValue={gads} onChange={this.onYearChange} />

                {loading ? <Loading /> : (
                    <div className="multifield-table-container">
                        <table className="table table-sm">
                            <thead style={{ whiteSpace: 'nowrap' }}>
                                <tr>
                                    <th rowSpan={2}>Krājuma kategorija</th>
                                    <th colSpan={2}>Krājumi {gads}. gada 1. janvārī (m3/d)</th>
                                    <th rowSpan={2}>Ieguve</th>
                                    <th colSpan={2}>Krājumu izmaiņas {gads}. gadā (m3/d)</th>
                                    <th colSpan={2}>Krājumi {gads + 1}. gada 1. janvārī (m3/d)</th>
                                    <th rowSpan={2}>Atradņu skaits</th>
                                </tr>
                                <tr>
                                    <th>Apstiprinātie līdz 1997. g.</th>
                                    <th>Akceptētie līdz {gads}. gadam</th>
                                    <th>Izpēte</th>
                                    <th>Pārrēķins</th>
                                    <th>Apstiprinātie līdz 1997. g.</th>
                                    <th>Akceptētie līdz {gads + 1}. gadam</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.kategorijuRindas(list).map(this.renderKategorijaRindas)}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = ({ pazemesUdenuBilanceKopsavilkums, location }) => ({
    pazemesUdenuBilanceKopsavilkums,
    query: location.query
})

export default connect(mapStateToProps, { addUrlQuery })(PazemesUdenuBilanceKopsavilkums)
